import moment from "moment";
import {
  FETCH_DOWNLOAD_DELETE_LANDING_BEGIN,
  FETCH_DOWNLOAD_DELETE_LANDING_SUCCESS,
  FETCH_DOWNLOAD_DELETE_LANDING_FAILURE
} from "../actions/types";

import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";
import { checkAMLob } from "utils/checkAMLob";

export const fetchDownloadAndDeleteLanding = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_DOWNLOAD_DELETE_LANDING_BEGIN });

  try {
    const response = await API({
      method: "POST",
      url: ENDPOINTS.REQUEST_STATUS
    });

    if (response && response.data && response.data.hasOwnProperty("elementsData")) {
      const { noOfAffidavitDownloadRemaining, noOfRegularDownloadRemaining } = response.data;

      const hasMadeRequest = response.data.elementsData.length || response.data.agentDetailsData.length ? true : false; //developer Arvind

      let payload = { ...response.data, hasMadeRequest };

      if (noOfAffidavitDownloadRemaining === 0 && noOfRegularDownloadRemaining === 0) {
        payload.maximumDownloadsReached = true;
      } else if (noOfAffidavitDownloadRemaining !== 0 && noOfRegularDownloadRemaining === 0) {
        payload.sensitivitySelection = "AFFIDAVIT";
      } else {
        payload.sensitivitySelection = "REGULAR";
      }

      for (let item of response.data.elementsData) {
        if (
          item.status === "PARTIALLY_COMPLETED" ||
          item.status === "PENDING_PROCESS" ||
          item.status === "PENDING" ||
          item.status === "IN_PROGRESS" ||
          item.status === "COMPLETED"
        ) {
          payload = {
            ...payload,
            ...item,
            shouldBannerRender: true,
            hasExtension: item.lastExtensionTaken && parseInt(item.lastExtensionTaken) > 0
          };

          // download
          //   - only show banner / modal for logged in mdn - wireless
          //   - show banner / modal for both pending and complete scenarios
          //
          // delete
          //   - show banner / modal for pending
          //   - only show banner for completed - do not show modal
          //   - only show green banner for 30 days past completion date
          if (
            item.requestType === "DELETE" &&
            ((checkAMLob() === "vzw" && item.loggedInMtn === window.reactGlobals.loggedInMdn) ||
              checkAMLob() !== "vzw")
          ) {
            if (item.status !== "COMPLETED") {
              payload.showPendingModal = true;
            } else {
              // CHANGE THIS VARIABLE WHEN CXP UPDATES THE RESPONSE
              const { downloadAvailabilityDate: deleteCompletionDate } = item;

              if (deleteCompletionDate && typeof deleteCompletionDate === "string") {
                const splitDate = deleteCompletionDate.split(".")[0].split("-");
                splitDate.pop();

                const newDate = splitDate.join("-");
                const withinThirtyDays = moment().isBefore(moment(newDate).add(30, "d"));

                if (!withinThirtyDays) {
                  payload.shouldBannerRender = false;
                }
              }
            }
          }

          if (
            checkAMLob() === "vzw" &&
            (item.requestType === "DOWNLOAD" ||
              item.requestType === "DOWNLOAD_AFFIDAVIT" ||
              item.requestType === "DELETE") &&
            window.reactGlobals.loggedInMdn !== payload.loggedInMtn
          ) {
            payload.shouldBannerRender = false;
          }
        }
        if (item.status === "COMPLETED") {
          if (item.requestType === "DOWNLOAD" || item.requestType === "DOWNLOAD_AFFIDAVIT") {
            if (moment().isBefore(moment(item.downloadAvailabilityDeadline).add(1, "d"))) {
              payload.downloadReady = true;
            } else {
              payload.shouldBannerRender = false; //false;
            }
          }
        }
      }

      dispatch({
        type: FETCH_DOWNLOAD_DELETE_LANDING_SUCCESS,
        payload
      });
    }
  } catch (error) {
    dispatch({ type: FETCH_DOWNLOAD_DELETE_LANDING_FAILURE });
  }
};
